import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';

import {
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';
import mailOcularImages from '../../helpers/ocularMailing';

import { FormikValues } from '../../components/SearchAllContent/types';

import { SearchOcularDB } from '../../components';

import './style.scss';

const HTTP_STATUS_OK = 200;

const SearchOcularDBFull = () => {
  const { t } = useTranslation();
  const [exportLoading, setExportLoading] = useState(false);

  const startExport = async (values: FormikValues) => {
    setExportLoading(true);
    const result = await mailOcularImages(values);
    if (result.status === HTTP_STATUS_OK) {
      toast.success(t('components.search_oculardb.export.success'));
    } else {
      toast.error(result.data.error || t('components.search_oculardb.export.error'));
    }
    setExportLoading(false);
  };

  return (
    <>
      <div className="SearchOcularDB__header">
        <Container>
          <h1 className="SearchOcularDB__header__title">{t('components.search_oculardb.title')}</h1>
          <h4 className="SearchOcularDB__header__subtitle">{t('components.search_oculardb.subtitle')}</h4>
        </Container>
      </div>
      <Container>
        <SearchOcularDB>
          <div className="row">
            <div className="col-12 mb-8 mb-lg-12">
              <SearchOcularDB.SearchBar />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-4 mb-8 mb-lg-0">
              <SearchOcularDB.Facets />
            </div>

            <div className="col-12 col-lg-8">
              <div className="d-flex justify-content-between align-items-center mb-8 mb-lg-6">
                <SearchOcularDB.Stats />
              </div>

              <FormikWrapper
                initialValues={{}}
                onSubmit={(values: FormikValues) => startExport(values)}
              >
                <SearchOcularDB.Results />
                <SearchOcularDB.Pagination className="mt-8" />
                <SearchOcularDB.Export isLoading={exportLoading} />
                <Toaster />
              </FormikWrapper>

              <SearchOcularDB.CTA />

            </div>
          </div>
        </SearchOcularDB>
      </Container>
    </>
  );
};

export default SearchOcularDBFull;
